import * as React from 'react';
function ArrowRightIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.20874 8.99997H12.3787L7.49874 13.88C7.10874 14.27 7.10874 14.91 7.49874 15.3C7.88874 15.69 8.51874 15.69 8.90874 15.3L15.4987 8.70997C15.8887 8.31997 15.8887 7.68997 15.4987 7.29997L8.91874 0.699971C8.52874 0.309971 7.89874 0.309971 7.50874 0.699971C7.11874 1.08997 7.11874 1.71997 7.50874 2.10997L12.3787 6.99997H1.20874C0.65874 6.99997 0.20874 7.44997 0.20874 7.99997C0.20874 8.54997 0.65874 8.99997 1.20874 8.99997Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ArrowRightIcon;
